import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

function DummyPay() {
  const location = useLocation()
  const [payload, setPayload] = useState({})
  const [userCart, setUserCart] = useState([])
  useEffect(()=>{
    const {userCart, payload} = location.state
    setPayload(payload)
    setUserCart(userCart)
    console.log(payload, userCart)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  

  const navigate = useNavigate()
  const handlePaymentFailure = () => {
    navigate('/payment-gateway/demo-pay/payment-failed',{state:{payload, userCart}})
  }
  const handlePaymentSuccess = () => {
    navigate('/payment-gateway/demo-pay/order-placed',{state:{payload, userCart}})
  }

  return (
    <div>
      <div className='w-full flex flex-col items-center justify-center gap-10 py-20'>
        <p className='text-lg text-slate-800 font-bodyFont font-extrabold'>DemoPayMenTsySteM</p>
        <div className='justify-between flex gap-3'>
        <button
                 className='bg-slate-900 text-red-500 text-base py-3 px-7 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'
                onClick={handlePaymentFailure}>
                Status Fail
            </button>
            <button
                 className='bg-slate-900 text-emerald-400 text-base py-3 px-7 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'
                onClick={handlePaymentSuccess}>
                Succeess
            </button>
        </div>
      </div>
    </div>
  )
}

export default DummyPay